import React, { useEffect } from "react";
import { connect } from "react-redux";
import { debug } from "../../utils";
import * as groupService from "./groupService";
import * as modalDataService from "./modalDataService";
import SelectV2 from "../../view/SelectV2";

function GroupField({ groups, groupId, disabled }) {


    useEffect(() => {
        groupService
            .list()
            .then((data) =>
                !groupId
                && data
                && modalDataService.changeGroup(data.find(group => group.id === Number(data[0].id)))
            );
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [])

    const onChange = (value) => {
        const group = groups.find(group => String(group.id) === String(value));
        modalDataService.changeGroup(group)
    };

    const groupOptions = groups.map((group) => ({
        value: group.id,
        label: group.name
    }));

    return (
        <div className="form-group">
            <div className="oct_form-group">
                <label htmlFor="group">Group <span className="modal-v2-required-mark">*</span></label>
                <SelectV2
                    inputId="group"
                    value={groupId || ""}
                    onChange={onChange}
                    options={groupOptions}
                    isDisabled={disabled}
                    placeholder="Select group"
                />
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("GroupField mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    const group = addDeviceModal.group;
    return {
        groups: addDeviceModal.groups || [],
        groupId: group ? group.id : null
    };
}

export default connect(mapStateToProps)(GroupField);
